import axios from 'axios';

export const sendRequest = axios.create({
    baseURL: 'https://mqqmwater.mwr.uz/api/',
    // timeout: 8000,
    headers: {
        Accept: 'application/json',
        Authorization: 'Bearer goKrtwJ_rnfE1XqjfhWoeeSYbNKF_0Zs'
    },
});

export const sendRequestQuduq = axios.create({
    baseURL: 'https://mqqmwell.mwr.uz/api/',
    // timeout: 8000,
    headers: {
        Accept: 'application/json',
        Authorization: 'Bearer 8GxEslZIppaK2y5f7xhGjh4ckkzBzl6P'
    },
});

export const sendRequestNasos = axios.create({
    baseURL: 'https://mqqmpump.mwr.uz/api/',
    // timeout: 8000,
    headers: {
        Accept: 'application/json',
        Authorization: 'Bearer r05n1tzeYtw26VL_SrpjJm_KBju10LRg'
    },
});

// export const GetStatistics = async () => {
//     try {
//         await sendRequest({
//             url: "statistics",
//             method: "GET",
//         }).then((res) => {
//             return res
//         });
//     } catch (e) {
//         return e
//     }
// }